<section class="listing-summary" [class.luxury]="listing.isLuxury" [class.commercial]="listing.isCommercial">
  <div #topsubbar id="topsubbar" class="is-flex sub-top">
    <app-back-button class="back-to" [showLabel]="false" [img]="backButton" [isRedesign]="!listing.isLuxury" ></app-back-button>
    <div class="is-flex listing-summary__button-container">
      <button *ngIf="!listing.isOffMarket && !listing.isLuxury" class="btn-redesign btn-redesign--primary btn-redesign--side-spacing btn-primary btn-polar-gradient" [class.commercial]="listing.isCommercial" (click)="showScheduleViewingClicked.emit($event)">
        <span [translate]="'contact.schedule-a-viewing'"></span>
      </button>
      <button *ngIf="!listing.isOffMarket && !listing.isLuxury" class="btn-redesign btn-redesign--secondary-on-color btn-redesign--side-spacing btn-primary btn-polar-gradient" [class.commercial]="listing.isCommercial" (click)="showContactAgentClicked.emit($event)">
        <span [translate]="listing.isLuxury? 'contact.request-more-details':'contact.request-more-info'"></span>
      </button>
      <button *ngIf="!listing.isOffMarket && listing.isLuxury" class="btn schedule-viewing btn-luxury" (click)="showScheduleViewingClicked.emit($event)">
        <span [translate]="'contact.schedule-a-viewing'"></span>
      </button>
      <button *ngIf="!listing.isOffMarket && listing.isLuxury" class="btn contact-agent btn-luxury" (click)="showContactAgentClicked.emit($event)">
        <span [translate]="listing.isLuxury? 'contact.request-more-details':'contact.request-more-info'"></span>
      </button>
    </div>
  </div>
  <section class="details-summary" [class.details-summary--offmarket] = "listing.isOffMarket" [class.details-summary--redesign] = "!listing.isLuxury">
    <div class="address is-flex has-flex-align-center">
      <div *ngIf="hasNextListings && !listing.isOffMarket" class="controls" (click)="previousListingClicked.emit($event)">
        <i *ngIf="listing.isLuxury" class="material-icons">chevron_left</i>
        <img *ngIf="!listing.isLuxury" class="control left" height="26" width="11" alt="Previous Listing"
             src="{{'/assets/icons/general_navigation/Chevron_left@1x.svg' | staticp}}"/>
      </div>
      <div class="flex-one text-center" [class.has-margin]="!hasCopiedText">
        <ng-container *ngIf="!hasCopiedText">
          <div *ngIf="listing.isOffMarket" class="details-off-market__not-for-sale"> <div class="details-off-market__not-for-sale-icon">!</div>{{ 'listing-summary.not-for-sale' | translate }}</div>
          <h1 class="full-address listing-details__address clipboard-text" [class.copied]="hasCopiedText"
          [attr.data-clipboard-text]="listing.address + ' ' + listing.city">{{ listing.address }}</h1>
          <h5>
            <app-listing-address class="clipboard-text" [class.copied]="hasCopiedText"
            [attr.data-clipboard-text]="listing.address + ' ' + listing.city" [isRedesign]="!listing.isLuxury" [isCommercial]="listing.isCommercial"
              [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
          </h5>
          <div class="is-flex has-flex-content-center" [ngStyle]="{'margin-bottom': listing.isLuxury ? 0 : '10px'}">
            <div class="has-pos-rel" 
              [class.commercial-share-button]="listing.isCommercial"
              [class.luxury-share-button]="listing.isLuxury"
              [class.residential-share-button]="!listing.isLuxury && !listing.isCommercial">
                <img class="luxury-share-button" (click)="isDropdownOpen = !isDropdownOpen" id="share-button-toggle" *ngIf="listing.isLuxury" style="margin-right:15px;" [src]="('/assets/icons/listing-details/share_dark_blue.svg') | staticp" height="20" width="20" role="button"/>
                <img [class.commercial-share-button]="listing.isCommercial" [class.residential-share-button]="!listing.isLuxury && !listing.isCommercial" (click)="isDropdownOpen = !isDropdownOpen" id="share-button-toggle" *ngIf="!listing.isLuxury"  style="margin-right:15px;" [src]="('/assets/icons/listing-details/share' + (listing.isCommercial ? '_red.svg' : '.svg')) | staticp" tabindex="1" height="20" width="20" role="button"/>

                <app-dropdown
                  [class.commercial-share-button]="listing.isCommercial" 
                  [class.residential-share-button]="!listing.isLuxury && !listing.isCommercial"
                  [listing]="listing"
                  [isMobile]="true"
                  [isOpen]="isDropdownOpen"
                  (toggleEmailModal)="showEmailModal = true; isDropdownOpen = false"
                  (onOutsideClick)="isDropdownOpen = false"></app-dropdown>

            </div>
            <img class="luxury-share-button" *ngIf="listing.isLuxury" style="margin-right:15px;" [src]="('/assets/icons/listing-details/print_dark_blue.svg') | staticp" (click)="openPrintListingPage($event)" height="20" width="20" role="button"/>
            <img [class.commercial-print-button]="listing.isCommercial" 
                  [class.residential-print-button]="!listing.isLuxury && !listing.isCommercial" *ngIf="!listing.isLuxury" style="margin-right:15px;" [src]="('/assets/icons/listing-details/print' + (listing.isCommercial ? '_red.svg' : '.svg')) | staticp" (click)="openPrintListingPage($event)" tabindex="2" height="20" width="20" role="button"/>

            <img 
              [class.commercial-favourite-button]="listing.isCommercial"
              [class.luxury-favourite-button]="listing.isLuxury"
              [class.residential-favourite-button]="!listing.isLuxury && !listing.isCommercial"
              [src]="listing.favouriteIconToUse | staticp"
              [title]="('gallery.aria.' + (listing.isFavourite ? 'unfavourite' : 'favourite')) | translate"
              class="" (click)="toggleFavourite($event)" height="20" width="20" role="button"/>
          </div>

          <div class="offmarket-poi-widget" *ngIf="listing.isOffMarket">
              <app-poi-widget [listing]="listing" ></app-poi-widget>
              <!-- <div class="details-off-market__image-overlay">
                {{ 'listing-summary.not-for-sale' | translate }}
              </div> -->
            </div>
            <div *ngIf="listing.isOffMarket" class="details-off-market">
              <div class="details-off-market__container">
                <div class="details-off-market__estimated-value-container"><div class="details-off-market__estimated-value-title">{{ 'listing-summary.estimated-value' | translate }}</div>
                <app-estimated-value [listing]="listing"></app-estimated-value>
              </div>
              <a (click)="homeEstimateLinkClick.emit($event)"
                class="details-off-market__find-estimated-value">
                  {{ 'listing-summary.find-value-of-another' | translate }} <i _ngcontent-c4="" class="material-icons">chevron_right</i>
              </a>
              <div class="details-off-market__offmarket-cta" *ngIf="!disableSellersLeadForm">
                  <h3>{{'listing-summary.estimates-refreshed-monthly' | translate}}</h3>
                  <p>{{'listing-summary.ask-remax-expert' | translate}}</p>
                  <span class="btn-redesign btn-redesign--primary btn-redesign--large" [class.commercial]="listing.isCommercial" translate="contact.consult-an-agent" (click)="showOffmarketCTAClicked.emit()" role="button" tabindex="0" (keydown.enter)="showOffmarketCTAClicked.emit()"></span>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasCopiedText">
          <div class="copied-text-view" translate="details.copied"></div>
        </ng-container>
      </div>
      <div *ngIf="hasNextListings  && !listing.isOffMarket" class="controls" (click)="nextListingClicked.emit($event)">
        <i *ngIf="listing.isLuxury" class="material-icons">chevron_right</i>
        <img *ngIf="!listing.isLuxury" class="control right" height="26" width="11" alt="Next Listing"
             src="{{'/assets/icons/general_navigation/Chevron_right@1x.svg' | staticp}}"/>
      </div>
    </div>
    <app-listing-card *ngIf="!listing.isOffMarket" [listing]="listing" [isListingDetails]="true" [isSelectedCard]="true" [includeAddress]="false"
                      [showMap]="showMap" [currentSlideIndex]="currentSlideIndex" [isRedesign] = "!listing.isLuxury"
                      (click)="toggleExpandedGalleryView.emit(true)" (changeCarouselIndex)="currentSlideIndex = $event">
      <p class="mortgage-payment-quick text-center" [class.mortgage-payment-quick--redesign] = "!listing.isLuxury"
         *ngIf="!listing.isLeaseOrRental && !listing.isCommercial && mortgagePaymentAmount"
         translate="details.estimated-mortgage-payment"
         [translateParams]="{frequency: 'Monthly', price: mortgagePaymentAmount}"></p>
    </app-listing-card>
  </section>
  <app-modal *ngIf="!listing.isOffMarket" [shouldShowModal]="showExpandedGalleryView" (closeModal)="toggleExpandedGalleryView.emit(false)"
             [templateRef]="expandedGalleryRef">
  </app-modal>
  <ng-template #expandedGalleryRef>
    <header class="is-flex has-flex-align-center" [class.commercial]="listing.isCommercial" [class.header--redesign]="!listing.isLuxury" style="margin-bottom: 20px;">
      <img *ngIf="!listing.isCommercial && !listing.isLuxury" src="{{'/assets/BalloonLarge.svg' | staticp}}"
           alt="RE/MAX Logo" height="73" width="56"/>
      <div class="flex-one is-flex-column">
        <div class="street-address">{{listing.address}}</div>
        <app-listing-address
          [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]" [isRedesign]="!listing.isLuxury" [isCommercial]="listing.isCommercial"></app-listing-address>
      </div>
    </header>
    <app-rm-carousel [images]="listing.imageUrls" [showHighDprImages]="true"
      (onChangeCarouselIndex)="currentSlideIndex = $event" [isCommercial]="listing.isCommercial"
      [currentSlideIndex]="currentSlideIndex" carouselParentName="expanded-view"
      [imageQualityPercentage]="100" [isRedesign]="!listing.isLuxury"></app-rm-carousel>

    <div *ngIf="!listing.isLuxury" style="display:flex; justify-content:flex-end;">
      <div class="favourites text-center favourites--redesign" (click)="toggleFavourite($event)">
        <img [src]="listing.isFavourite ? ('/assets/icons/heart/heart_icon_red.svg' | staticp ) : (listing.isCommercial ? ('/assets/icons/heart/heart_icon_commercial.svg' | staticp ) : ('/assets/icons/heart/heart_icon.svg' | staticp ))" height="17" width="18" alt="Favourite"/>
      </div>
    </div>

    <a class="btn-full-sized request-more-info__button" [class.btn]="listing.isLuxury" [class.btn-primary]="listing.isLuxury" [class.btn-redesign]="!listing.isLuxury" [class.btn-redesign--primary]="!listing.isLuxury" [class.commercial]="listing.isCommercial" [class.btn-redesign--side-spacing]="!listing.isLuxury"  [class.btn-redesign--max-size-260]="!listing.isLuxury" translate="contact.request-more-info"
      (click)="showContactAgentClicked.emit($event)"></a>

    <div *ngIf="listing.isLuxury" style="display: flex; flex-direction: column;">
      <div style="text-align: center;"
            (click)="toggleFavourite($event)" tabindex="0" (keydown.enter)="toggleFavourite($event)">
        <a style="margin-right: 10px;"
            [translate]="listing.isFavourite ? 'listing-summary.remove-from-saved-listings' : 'listing-summary.add-to-saved-listings'"></a>
        <img
          [src]="listing.isFavourite ? ('/assets/icons/heart/heart_icon_red.svg' | staticp ) : ('/assets/icons/heart/heart_icon.svg' | staticp )"
          height="17" width="18"
          [alt]="('listing-summary.' + (listing.isFavourite ? 'remove-from' : 'add-to') + '-saved-listings' ) | translate"/>
      </div>
    </div>

  </ng-template>
</section>


<app-modal [isRedesign]="true"
[templateRef]="shareEmailModal"
[shouldShowModal]="showEmailModal"
(closeModal)="showEmailModal = false"
[isFullHeight]="true"></app-modal>
<ng-template #shareEmailModal>
  <app-email-share-modal [isLuxury]="listing.isLuxury" [fromEmail]="sessionEmail"
  [subjectTitle]="listing.address + ', ' + listing.city + ', ' + listing.province + ', ' + listing.postalCode"
  [url]="cdnUrl + listing.detailUrl.substring(1, listing.detailUrl.length)"
  [description]="listing.description" (submitted)="showRequestSent = true; showEmailModal = false"></app-email-share-modal>
</ng-template>

<app-request-sent [isShareForm]="true" *ngIf="showRequestSent" (onClose)="showRequestSent = false"></app-request-sent>
